import { render, staticRenderFns } from "./TheWebRTCVideoSetup.vue?vue&type=template&id=0587b45b&scoped=true&lang=html"
import script from "./TheWebRTCVideoSetup.vue?vue&type=script&lang=ts"
export * from "./TheWebRTCVideoSetup.vue?vue&type=script&lang=ts"
import style0 from "./TheWebRTCVideoSetup.vue?vue&type=style&index=0&id=0587b45b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587b45b",
  null
  
)

export default component.exports